import { apiInstance2 } from "../utils/apiInstance";
import { getHeaders } from "utils/request";

const apis = {
  listAndFilterTransactions: ({ payload, tribeRef, page }) =>
    apiInstance2(`/trapmen/list_general_transactions/?page=${page}`, {
      method: "POST",
      body: payload,
      headers: {
        ...getHeaders({ tribeRef }),
      },
    }),
  getCryptoTransactionsList: ({ payload, tribeRef, page }) =>
    apiInstance2(`/trapmen/list_crypto_payin/?page=${page}`, {
      method: "POST",
      body: payload,
      // headers: {
      //   ...getHeaders({ tribeRef }),
      // },
    }),
  getTransactionDetails: ({ transaction_reference, tribeRef }) =>
    apiInstance2(
      `/trapmen/single_general_transaction/${transaction_reference}/`,
      {
        headers: {
          ...getHeaders({ tribeRef }),
        },
      }
    ),
  getFiatPayinDetails: ({ transaction_reference }) =>
    apiInstance2(`/trapmen/fiat_payinbyref_detail/${transaction_reference}/`),
  searchTransactions: ({ data }) =>
    apiInstance2(`/trapmen/direct_general_tx_search/`, {
      method: "POST",
      data,
    }),

  search9PSBTransactions: ({ data }) =>
    apiInstance2(`/trapmen/alt_verify_psb_payout/`, {
      method: "POST",
      data,
    }),

  exportAccountTransactions: (data) =>
    apiInstance2(`/trybe/csv_per_account_export/`, {
      method: "POST",
      data,
    }),
};

export default apis;
